<template>
  <b-row>
    <b-col cols="8" class="container">
      <b-row>
        <LeftTab
          :complaintData="complaintData"
          :IsAllowDelete_PersonDataDigital="false"
          :IsReadOnly_PersonDataDigital="true"
          :personals="personals"
          :attorneys="attorneys"
          :IsEdit_CompanyDetail="false"
          :IsDeleteAble_CompanyDetail="false"
          :IsReadOnly_CompanyDetail="true"
          :IsEdit_CompanySearch="false"
          :complainantCompany="complainantCompany"
          :IsReadOnly_ComplaintDetail="true"
          :complaintDetail="complaintDetail"
          :complaintCatagoryDetail="complaintCatagoryDetail"
          :complaintDetailMultiSelect="complaintDetailMultiSelect"
          :company="complaintData"
          :IsEdit_TabAttachFiles="false"
          :attachFiles="attachFiles"
          :attachFileDate="attachFileDate"
          :attachFilesType2="attachFilesType2"
          :attachFileDateType2="attachFileDateType2"
          :fileFormstatusModel="fileFormstatusModel"
          :fileFormstatusModelDates="fileFormstatusModelDates"
          :fileFormstatusType3Model="fileFormstatusType3Model"
          :fileFormstatusType3ModelDates="fileFormstatusType3ModelDates"
          :fileFormstatusType4Model="fileFormstatusType4Model"
          :fileFormstatusType4ModelDates="fileFormstatusType4ModelDates"
          :IsEditData="false"
        />
      </b-row>
    </b-col>
    <b-col cols="4">
      <b-card>
        <TrackingComplaint
          :hightlightLasted="true"
          @handle-update-comment="onUpdateCommentClicked"
        />
        <div class="d-flex justify-content-end">
          <b-button
            variant="success"
            class="ml-1"
            @click="onTrackingComplaintStepBackClicked"
            >ลบสถานะหน่วยงานล่าสุด</b-button
          >
          <b-button
            variant="primary"
            class="ml-1"
            @click="onTrackingComplaintDetailStepBackClicked"
            >ลบสถานะล่าสุด</b-button
          >
        </div>

        <b-tabs class="mt-2">
          <b-tab id="tab-send-1" title="ส่งต่อหน่วยงานภายใน">
            <div class="mt-2 mb-1">
              <ValidationObserver ref="form">
                <ValidationProvider
                  rules="required"
                  name="หน่วยงาน"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    class="ml-1 "
                    label="หน่วยงาน"
                    label-for="officer"
                  >
                    <vue-select
                      label="text"
                      :required="true"
                      v-model="internalDep"
                      :options="internalDeps"
                      @input="selectOnInput"
                      class="mt-1"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                  rules="required"
                  name="เจ้าหน้าที่ผู้ดำเนินการ"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    class="ml-1 mt-1"
                    label="เจ้าหน้าที่ผู้ดำเนินการ"
                    label-for="officer"
                  >
                    <vue-select
                      label="text"
                      :required="true"
                      v-model="officer"
                      :options="officers"
                      @input="selectOnInput"
                      class="mt-1"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                  rules="required"
                  name="ความเห็นเจ้าหน้าที่"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    label="ความเห็นเจ้าหน้าที่"
                    label-for="offficerComment"
                    class="ml-1 mt-1"
                  >
                    <b-form-textarea
                      id="offficerComment"
                      placeholder="ความเห็นเจ้าหน้าที่"
                      rows="6"
                      v-model="comment"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>
            </div>
            <div class="d-flex justify-content-end">
              <b-button
                variant="primary"
                class="ml-1"
                @click="onTrackingSendInternalDep"
                >ส่งต่อหน่วยงานภายใน</b-button
              >
            </div>
          </b-tab>
          <b-tab id="tab-send-2" title="ส่งต่อจังหวัด">
            <div class="mt-2 mb-1">
              <ValidationObserver ref="form2">
                <ValidationProvider
                  rules="required"
                  name="จังหวัด"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    class="ml-1 "
                    label="จังหวัด"
                    label-for="province"
                  >
                    <vue-select
                      label="text"
                      :required="true"
                      v-model="province"
                      :options="provinces"
                      @input="selectOnInput"
                      class="mt-1"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                  rules="required"
                  name="เจ้าหน้าที่ผู้ดำเนินการ"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    class="ml-1 mt-1"
                    label="เจ้าหน้าที่ผู้ดำเนินการ"
                    label-for="officer"
                  >
                    <vue-select
                      label="text"
                      :required="true"
                      v-model="officer"
                      :options="officers"
                      @input="selectOnInput"
                      class="mt-1"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                  rules="required"
                  name="ความเห็นเจ้าหน้าที่"
                  v-slot="{ errors }"
                >
                  <div class="w-100">
                    <b-form-textarea
                      id="offficerComment"
                      placeholder="ความเห็นเจ้าหน้าที่"
                      rows="6"
                      v-model="comment"
                      class="mt-1 pl-1"
                    />
                  </div>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>
            </div>
            <div class="d-flex justify-content-end">
              <b-button
                variant="info"
                class="ml-1"
                @click="onTrackingSendProvince"
                >ส่งต่อจังหวัด</b-button
              >
            </div>
          </b-tab>
          <b-tab id="tab-send-3" title="แก้ไขช่องทาง">
            <div class="mt-2 mb-1">
              <ValidationObserver ref="form3">
                <ValidationProvider
                  rules="required"
                  name="ช่องทาง"
                  v-slot="{ errors }"
                >
                  <div class="w-100">
                    <vue-select
                      label="text"
                      :required="true"
                      v-model="channel"
                      :options="channels"
                      @input="selectOnInput"
                      class="mt-1 pl-1"
                    />
                  </div>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>
            </div>
            <div class="d-flex justify-content-end">
              <b-button
                variant="outline-primary"
                class="ml-1"
                @click="onTrackingComplaintChangeChannel"
                >แก้ไขช่องทาง</b-button
              >
            </div>
          </b-tab>
          <b-tab id="tab-send-4" title="ลบเรื่องร้องทุกข์">
            <div class="mt-2 mb-1">
              <ValidationObserver ref="form4">
                <ValidationProvider
                  rules="required"
                  name="รหัสยืนยัน"
                  v-slot="{ errors }"
                >
                  <b-form-group
                    label="รหัสยืนยัน"
                    label-for="deletePin"
                    class="ml-1 mt-1"
                  >
                    <span class="text-danger">กรอกคำว่า ลบข้อมูล</span>
                    <b-form-input
                      id="deletePin"
                      placeholder="กรอกคำว่า ลบข้อมูล"
                      v-model="deletePin"
                      autocomplete="off"
                    />
                  </b-form-group>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>
            </div>
            <div class="d-flex justify-content-end">
              <b-button variant="danger" class="ml-1" @click="onDelete"
                >ลบเรื่องร้องทุกข์</b-button
              >
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
    <UpdateCommentModal ref="modal-update-comment" />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BTab,
  BTabs,
} from "bootstrap-vue";
import LeftTab from "@/views/Complaint/components/LeftTabAction.vue";
import TrackingComplaint from "@/views/Complaint/components/TrackingComplaint/TrackingComplaint.vue";
import UpdateCommentModal from "./components/UpdateCommentModal.vue";
import VueSelect from "vue-select";

import * as complaintStore from "@/store/api/complaint/complaint.js";
import * as complaintManageStore from "@/store/api/complaintManage/index.js";
import * as storeMaster from "@/store/api/master/index.js";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BTab,
    BTabs,
    LeftTab,
    TrackingComplaint,
    UpdateCommentModal,
    VueSelect,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      personals: [],
      attorneys: [],
      complainantCompany: [],
      currentUserIdModal: "",
      currentCompIdModal: "",
      currentCompanyModal: {},
      complaintData: {},
      complaintDetail: [],
      complaintDetailMultiSelect: [],
      complaintCatagoryDetail: [],
      masterIdList: [],
      complainId: null,
      attachFiles: [],
      attachFileDate: [],
      attachFilesType2: [],
      attachFileDateType2: [],
      fileFormstatusModel: [],
      fileFormstatusModelDates: [],
      fileFormstatusType3Model: [],
      fileFormstatusType3ModelDates: [],
      fileFormstatusType4Model: [],
      fileFormstatusType4ModelDates: [],

      internalDep: null,
      internalDeps: [],
      comment: "",
      province: null,
      provinces: [],
      deletePin: "",
      officers: [],
      officer: null,
      channels: [],
      channel: null,
    };
  },
  mounted() {
    this.getComplaintById(this.$route.query.id);
    this.getInternalDeps();
    this.getProvinces();
    this.getOfficer();
    this.getChannels();
  },
  methods: {
    onTrackingSendInternalDep() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.onSubmitBtnClicked("TrackingComplaintSendToDep");
      });
    },
    onTrackingSendProvince() {
      this.$refs.form2.validate().then((success) => {
        if (!success) {
          return;
        }
        this.onSubmitBtnClicked("TrackingComplaintSendToProvince");
      });
    },
    onTrackingComplaintStepBackClicked() {
      this.onSubmitBtnClicked("TrackingComplaintStepBack");
    },
    onTrackingComplaintDetailStepBackClicked() {
      this.onSubmitBtnClicked("TrackingComplaintDetailStepBack");
    },
    onTrackingComplaintChangeChannel() {
      this.$refs.form3.validate().then((success) => {
        if (!success) {
          return;
        }
        this.onSubmitBtnClicked("UpdateChannel");
      });
    },
    onUpdateCommentClicked(trackingDetailId, oldComment) {
      console.log("onUpdateCommentClicked", trackingDetailId, oldComment);
      this.$refs["modal-update-comment"].$refs["modal-update-comment"].show();
      this.$refs["modal-update-comment"].setModalData(
        trackingDetailId,
        oldComment
      );
    },
    onSubmitBtnClicked(mode) {
      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let userActive = null;

          let depId = null;
          if (mode === "TrackingComplaintSendToDep") {
            depId = _this.internalDep.value;
            userActive = _this.officer.value;
          }

          let provinceCode = null;
          if (mode === "TrackingComplaintSendToProvince") {
            provinceCode = _this.province.value;
            userActive = _this.officer.value;
          }

          let channelId = null;
          if (mode === "UpdateChannel") {
            channelId = _this.channel.value;
          }

          const params = {
            mode,
            complaintId: _this.$route.query.id,
            comment: _this.comment,
            departmentId: depId,
            provinceCode: provinceCode,
            userActive,
            channelId,
          };
          complaintManageStore
            .updateItem(params)
            .then((response) => {
              if (response.data.success === true) {
                _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });
                _this.$router.go(_this.$router.currentRoute);
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
    onDelete() {
      this.$refs.form4.validate().then((success) => {
        if (!success) {
          return;
        }

        const _this = this;

        this.$swal({
          title: "ยืนยันการลบข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (_this.deletePin !== "ลบข้อมูล") {
            _this.$bvToast.toast("กรุณากรอกรหัสยืนยันให้ถูกต้อง", {
              title: `เกิดข้อผิดพลาด`,
              variant: "danger",
              solid: false,
            });

            return;
          }
          if (result.value) {
            const params = {
              complaintId: _this.$route.query.id,
            };
            complaintManageStore
              .deleteItem(params)
              .then((response) => {
                if (response.data.success === true) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });
                  //_this.$router.push("ComplaintManage");
                  const routeData = this.$router.resolve({
                    name: "ComplaintManage",
                  });
                  window.open(routeData.href, "_self");
                } else {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              });
          }
        });
      });
    },
    getInternalDeps() {
      const _this = this;

      storeMaster
        .getDepartment(2)
        .then(function(response) {
          // handle success
          // console.log("response", response);
          _this.internalDeps = response.data.data;
          _this.internalDep = _this.internalDeps[0];

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    getProvinces() {
      const _this = this;

      storeMaster
        .getProvince()
        .then((response) => {
          _this.provinces = response.data.data;
          _this.province = _this.provinces[0];
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getOfficer() {
      const _this = this;
      storeMaster
        .getOfficerInfoAll()
        .then(function(response) {
          var setDataList = [];

          response.data.data.forEach((o) => {
            var setData = {};
            setData.value = o.user_id;
            setData.text = o.title_name + " " + o.fname + " " + o.lname;

            setDataList.push(setData);
          });

          const officerUnique = [
            ...new Map(
              setDataList.map((item) => [item["value"], item])
            ).values(),
          ];

          //_this.officers.push(...setDataList);
          _this.officers = officerUnique;
          _this.officer = _this.officers[0];

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    getChannels() {
      const _this = this;
      storeMaster
        .getMasterByType(1)
        .then((response) => {
          const masters = response.data.data.map(function(obj) {
            return { value: obj.masterId, text: obj.description };
          });
          console.log("masters", masters);
          _this.channels = masters;
          _this.channel = _this.channels[0];
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getComplaintById(id) {
      const _this = this;
      //console.log('userData.userId', userData.userId())
      //console.log('userData.departmentId', userData.departmentId())
      complaintStore
        .getComplaintById(id)
        .then(function(response) {
          // handle success

          console.log("GetComplaintById", response);

          _this.personals = response.data.data.personals;
          _this.attorneys = response.data.data.attorneys;
          _this.complaintData = response.data.data.complaintModel;
          _this.complainantCompany = response.data.data.complainantCompany;
          _this.attachFiles = response.data.data.attachFiles;
          _this.attachFileDate = response.data.data.attachFileDate;
          _this.attachFilesType2 = response.data.data.attachFilesType2;
          _this.attachFileDateType2 = response.data.data.attachFileDateType2;
          _this.fileFormstatusModel = response.data.data.fileFormstatusModel;
          _this.fileFormstatusModelDates =
            response.data.data.fileFormstatusModelDates;
          _this.fileFormstatusType3Model =
            response.data.data.fileFormstatusType3Model;
          _this.fileFormstatusType3ModelDates =
            response.data.data.fileFormstatusType3ModelDates;
          _this.fileFormstatusType4Model =
            response.data.data.fileFormstatusType4Model;
          _this.fileFormstatusType4ModelDates =
            response.data.data.fileFormstatusType4ModelDates;
          _this.complaintDetail = response.data.data.complaintDetail;
          _this.complaintDetailMultiSelect =
            response.data.data.complaintDetailMultiSelect;
          _this.complaintCatagoryDetail =
            response.data.data.complaintCatagoryDetail;

          _this.complaintDetail.forEach((value, index) => {
            value.tmMasterList.forEach((value2, index2) => {
              if (value2.checked === true) {
                _this.masterIdList.push(value2.masterId);
              }
            });
          });

          const filterAttach = _this.attachFiles.filter((value) => {
            return value.createDateStr === _this.attachFileDate[0];
          });

          console.log(
            "_this.attachFileDate",
            _this.attachFileDate,
            filterAttach
          );
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
